var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdgrpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "translate(24) scale(-1 1)",
    fill: "white",
    stroke: "#2D9CDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.424 11.184L8.384 8.768H3.696L2.656 11.184H0L4.832 0H7.248L12.08 11.184H9.424ZM6.048 3.328L4.64 6.576H7.44L6.048 3.328Z",
    transform: "translate(6 6)",
    fill: "#2D9CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdgrpIcon);
export default __webpack_public_path__ + "static/media/adgrp-icon.bc7c2648550ca32013b3dd52f698030a.svg";
export { ForwardRef as ReactComponent };